import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogService } from 'ng2-bootstrap-modal';
import { UtilsService } from 'ng2-date-picker/lib/common/services/utils/utils.service';
import { ConfigurationService } from 'src/app/shared/architecture/services/configuration.service';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { BilledFilter } from 'src/app/shared/models/billedFilter.model';
import { BilledService } from 'src/app/shared/services/core/billed.service';

@Component({
  selector: 'app-faturadas',
  imports: [TegelModule, CommonModule],
  templateUrl: './faturadas.component.html',
  styleUrl: './faturadas.component.scss'
})
export class FaturadasComponent implements OnInit {
  billed: any[];
  row: any;
  billedFilter: BilledFilter;
  page = 1;
  total: number = 0;
  reverse: boolean = false;
  order = "ID";

  constructor(
    private dialogService: DialogService, 
    private utilService: UtilService, 
    private billedService: BilledService, 
    private configurationService: ConfigurationService,
    private util: UtilService
  ){
    this.billedFilter = new BilledFilter();
    this.billed = [];
  }

  ngOnInit(): void { }

  // chooseClient() {
  //   this.dialogService.addDialog(ClientComponent, {}, this.utilService.getModalOptions()).subscribe((result) => {
  //     if (result && result.client != null) {
  //       const client = result.client;
  //       this.billedFilter.clientId = client.id;
  //       this.billedFilter.corporateName = client.corporateName;
  //     }
  //   });
  // }

  // getAllBilled(page: number) {
  //   this.billedService.get(page, this.order, this.utilService.getModalOptions()).subscribe((result) => {
  //     this.billed = result.page;
  //     this.page = result.currentPage;
  //     this.total = result.totalRecords;
  //   });
  // }

  resetFilter(form: NgForm) {
    this.billedFilter = new BilledFilter();
    form.resetForm(this.billedFilter);
  }

  rowSelected(billed: any) {
    this.row = billed;
  }

  search() {
    this.rowSelected(null);
    //this.getAllBilled(1);
  }

  // viewDraft() {
  //   window.open(localStorage.getItem('ffsDatabase') + this.util.getOwnerEnv() + "/psf_frame.fView?pFile=" + this.row.file , '_blank');
  // }

}
